import { color } from './color';
import font from './font';

export default {
  MuiPickersToolbar: {
    toolbar: {
      backgroundColor: color.blue2,
    },
  },
  MuiPickersToolbarText: {
    toolbarTxt: {
      color: 'rgba(255, 255, 255, 0.54)'
    },
    toolbarBtnSelected: {
      color: color.light
    }
  },
  MuiPickersClock: {
    pin: {
      backgroundColor: color.blue2
    }
  },
  MuiPickersClockPointer: {
    pointer: {
      backgroundColor: color.blue2
    },
    thumb: {
      backgroundColor: color.light,
      borderColor: color.blue2
    },
    noPoint: {
      backgroundColor: color.blue2
    },
  },
  MuiPickersDay: {
    day: {
      '& p': {
        fontFamily: font.openSans,
        fontSize: 12,
      }
    },
    daySelected: {
      color: color.light,
      backgroundColor: color.blue2,
      '&:hover': {
        backgroundColor: color.blue2,
      }
    },
    current: {
      color: color.blue2
    },
  },
  MuiDialogActions: {
    root: {
      '& button': {
        color: color.darkBlue
      }
    }
  },
  MuiPickersClockNumber: {
    clockNumberSelected: {
      color: color.light,
      backgroundColor: color.blue2,
    }
  }
};